import type { FC } from "react";
import { compose } from "redux";
import withSecondaryBarSet from "../../hoc/withSecondaryBarSet";
import Management from "./components/Management/Management";
import { withCacheToken } from "../manage-export/hoc/withCacheToken";

const ManagementPageContainer = compose(
    withSecondaryBarSet("SalesIntelligenceManagement"),
    withCacheToken,
)(Management) as FC;

export default ManagementPageContainer;
